import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
  Form,
  Dropdown

} from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import { logoutUser } from "../../actions/auth";
import { closeSidebar, openSidebar } from "../../actions/navigation";
import MenuIcon from "../Icons/HeaderIcons/MenuIcon";
import SearchBarIcon from "../Icons/HeaderIcons/SearchBarIcon";
import SearchIcon from "../Icons/HeaderIcons/SearchIcon";

import ProfileIcon from "../../assets/navbarMenus/pfofileIcons/ProfileIcon";
import MessagesIcon from "../../assets/navbarMenus/pfofileIcons/MessagesIcon";
import TasksIcon from "../../assets/navbarMenus/pfofileIcons/TasksIcon";

import logoutIcon from "../../assets/navbarMenus/pfofileIcons/logoutOutlined.svg";
import basketIcon from "../../assets/navbarMenus/basketIcon.svg";
import calendarIcon from "../../assets/navbarMenus/calendarIcon.svg";
import envelopeIcon from "../../assets/navbarMenus/envelopeIcon.svg";
import mariaImage from "../../assets/navbarMenus/mariaImage.jpg";
import notificationImage from "../../assets/navbarMenus/notificationImage.jpg";
import userImg from "../../assets/abr_logo.png";
import test from "./download.jpeg";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import profileIcon from "../../assets/profileIcon.png";

import s from "./Header.module.scss";
import "animate.css";
import door from "./blue-door.gif"
import BaseAPI from '../../api/apiurl';

const Header = (props) => {

  const [menuOpen, setMenuOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [customer, setCustomer] = useState("");
  const [vendorname, setVendorname] = useState("");
  const [clogo, setCLogo] = useState('');
  const [modal, setModal] = useState(false);
  const [companyLogo , setCompanyLogo] = useState(' ');


  const [apiData, setApiData] = useState(null);

  const fetchData = async () => {
    try {
   
      const company_id = localStorage.getItem('companyid');
      const customer_id = localStorage.getItem('customerid');   
      const response = await fetch(`${BaseAPI}headerapi?company_id=${company_id}&customer_id=${customer_id}`);
      const data = await response.json();
      setApiData(data);
      setCustomer(data.data.customer);
      setVendorname(data.data.vendorname);
      setCLogo(data.data.vendorlogo);
      setCompanyLogo(data.data.customerlogo)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  

  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  }

  const toggle = () => {
    setModal(!modal);
  };

  

  const toggleSidebar = () => {
    if (props.sidebarOpened) {
      props.dispatch(closeSidebar());
    } else {
      const paths = props.location.pathname.split('/');
      paths.pop();
      props.dispatch(openSidebar());
    }
  }

  // const doLogout = () => {
  //   props.dispatch(logoutUser());
  // }

  useEffect(() => {
   

    fetchData();
  }, []);

  useEffect(() => {
    
    const storedCustomerName = localStorage.getItem("username");

    console.log("Stored customer name:", storedCustomerName);

    if (storedCustomerName) {
      setCustomerName(storedCustomerName);
    }
  }, []);

  function logoutUser() {
   

    localStorage.clear();


    
    window.location.href = '#/login'; 
    toggle();
  }

  function handelprofile() {

    const baseUrl = process.env.PUBLIC_URL;

    // Concatenate the base URL with the desired path
    const newPath = `${baseUrl}#/timeinlive/profileAdmin`;

    // Navigate to the new URL
    window.location.href = newPath;
  }

  function handelprofileuser() {

    const baseUrl = process.env.PUBLIC_URL;

    // Concatenate the base URL with the desired path
    const newPath = `${baseUrl}#/timeinlive/profileUser`;

    // Navigate to the new URL
    window.location.href = newPath;
  }

  const userRole = localStorage.getItem('role');
  const AdminRole = localStorage.getItem('role');
  // const vendorname  = localStorage.getItem('vendorname');
  // const customer    = localStorage.getItem('customer');
  
 


  return (
    <div style={{ position: "fixed", top: "0",   width: 'calc(100% - 250px)', zIndex: "1" }}>
      <Navbar className={`${s.root} d-print-none`} style={{ backgroundColor: 'white', color: 'white' }}>
     
      <h1 className={`small d-none d-sm-block ml-1 mr-2 body-1`}>
      
  <span style={{ color: '#FF7028', fontFamily: 'Arial', fontSize: '28px', fontWeight: 'bold' }}>{vendorname}</span><br />
  {/* <span style={{ color: '#0D2CA9', fontFamily: 'Times New Roman', fontSize: '20px', fontWeight: 'bold' }}>{customer}</span> */}
</h1>

        <div>
          <NavLink
            onClick={() => toggleSidebar()}
            className={`d-md-none mr-3 ${s.navItem}`}
            href="#"
          >
            <MenuIcon className={s.menuIcon} />
          </NavLink>
        </div>
        <Form className="d-none d-sm-block" inline>
        </Form>
        <Nav className="ml-auto" >
          <NavItem className="d-sm-none mr-4">
            <NavLink
              className=""
              href="#"
            >
              <SearchIcon />
            </NavLink>
          </NavItem>

         
          <Dropdown isOpen={notificationsOpen} toggle={() => toggleNotifications()} nav id="basic-nav-dropdown" className="ml-3">
            <DropdownToggle nav caret className="navbar-dropdown-toggle">
            <span className={`${s.avatar} rounded-circle float-left mr-2`}>
    {clogo ? (
        <img src={`data:image/png;base64,${clogo}`} alt="Customer Logo" width="60" height="30" />
    ) : (
        <img src={profileIcon} alt="Default Logo" width="60" height="30" />
    )}
</span>
              <span className="small d-none d-sm-block ml-1 mr-2 body-1" style={{ zIndex: 1000, color: 'red' }}>{customerName}</span>
            </DropdownToggle>
            <DropdownMenu className="navbar-dropdown profile-dropdown" style={{ width: "194px" }}>
            {(userRole === 'A' || userRole === 'U' ) && (
              <DropdownItem className={s.dropdownProfileItem} onClick={handelprofile}><ProfileIcon /><span>Profile</span></DropdownItem>
              )}
               {(AdminRole === '1' || AdminRole === '2') &&  (
              <DropdownItem className={s.dropdownProfileItem} onClick={handelprofileuser}><ProfileIcon /><span>Profile</span></DropdownItem>
              )}
              <NavItem>
                <NavLink>
                  <button
                    className="btn btn-primary rounded-pill mx-auto logout-btn"
                    type="submit"
                    onClick={toggle}>
                    <span className="ml-1">Logout</span>
                  </button>
                </NavLink>
              </NavItem>
            </DropdownMenu>
          </Dropdown>
        
        </Nav> &nbsp;
        {/* <button
                    className="btn btn-danger  rounded-pill"
                    type="submit"
                    onClick={toggle}
                    style={{ fontSize: '12px', padding: '5px 5px' }}>
                    <span >Logout</span>
                  </button> */}
      </Navbar>
     
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Logout Confirmation</ModalHeader>
        <ModalBody>
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: "red", fontWeight: "bold" }}>Are you sure you want to logout?</p>
            <img
              src={door} // Replace with the URL of your GIF
              alt="Logout GIF"
              width="30%"
              style={{ display: "block", margin: "0 auto" }}
            />
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="danger" onClick={logoutUser}>
            Logout
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

Header.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sidebarOpened: PropTypes.bool,
}

function mapStateToProps(store) {
  return {
    sidebarOpened: store.navigation.sidebarOpened,
    sidebarStatic: store.navigation.sidebarStatic,
  };
}

export default withRouter(connect(mapStateToProps)(Header));

